import MojitoServices from 'mojito/services';
import MojitoCore from 'mojito/core';
import SearchView from 'applications/sports/components/search/search-view/index.js';
import MojitoPresentation from 'mojito/presentation';
import { connect } from 'react-redux';
import { selectRoute } from 'applications/common/stores/router/selectors.js';
import { memoize, omit } from 'mojito/utils';

const { RESULT_TYPE } = MojitoServices.Search.types;
const { selectSports } = MojitoServices.SportsContent.Sports.selectors;
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const { selectRecentSearches, selectResult } = MojitoServices.Search.selectors;
const searchActions = MojitoServices.Search.actions;
const { byDisplayOrder } = MojitoPresentation.Utils.SortingHelper;

class SearchControllerView extends UIViewImplementation {
    constructor(props) {
        super(props);

        this.state = {
            selectedSportId: undefined,
        };
        this.onRemoveRecentSearch = this.onRemoveRecentSearch.bind(this);
        this.onSportClick = this.onSportClick.bind(this);
        this.groupSearchResult = memoize(this.groupSearchResult);
    }

    componentDidUpdate(prevProps) {
        // reset selected sport on next search request
        if (
            this.state.selectedSportId &&
            this.props.searchResult.pending &&
            !prevProps.searchResult.pending
        ) {
            this.setState({
                selectedSportId: undefined,
            });
        }
    }

    onRemoveRecentSearch(query) {
        this.emitAnalytics('searchHistoryItemRemoved', query);
        this.props.dispatch(searchActions.removeRecentSearch({ query }));
    }

    onSportClick(selectedSportId) {
        this.setState({ selectedSportId });
    }

    groupSearchResult(searchResultItems = []) {
        const grouped = {};

        for (const item of searchResultItems) {
            if (!grouped[item.sportId]) {
                grouped[item.sportId] = {
                    [RESULT_TYPE.EVENT]: [],
                    [RESULT_TYPE.RACE_MEETING]: [],
                    [RESULT_TYPE.SPORT]: [],
                    [RESULT_TYPE.TYPE]: [],
                };
            }

            // Group by player name and result type
            if (item.playerName) {
                grouped[item.sportId][item.playerName] =
                    grouped[item.sportId][item.playerName] || [];
                grouped[item.sportId][item.playerName].push(omit(item, 'playerName'));
            } else {
                grouped[item.sportId][item.resultType].push(item);
            }
        }

        return grouped;
    }

    getSportMenuItems() {
        const { sports } = this.props;
        const searchResultGrouped = this.groupSearchResult(this.props.searchResult.items);

        if (!sports?.length || !Object.keys(searchResultGrouped).length) {
            return [];
        }

        const sportItems = Object.keys(searchResultGrouped).map(sportId => {
            const item = sports.find(sport => sport.id === sportId);
            if (!item) {
                return;
            }
            const { id, name: data, displayOrder } = item;

            return {
                id,
                data,
                displayOrder,
            };
        });

        return sportItems
            .filter(Boolean)
            .sort(byDisplayOrder)
            .map(({ id, data }) => ({ id, data }));
    }

    getSelectedSport() {
        const searchResultGrouped = this.groupSearchResult(this.props.searchResult.items);

        const { selectedSportId } = this.state;

        const firstValidSportId = this.getSportMenuItems().find(sport => {
            return Object.hasOwn(searchResultGrouped, sport.id);
        })?.id;

        return searchResultGrouped[selectedSportId] ? selectedSportId : firstValidSportId;
    }

    render() {
        const menuItems = this.getSportMenuItems();
        const selectedSport = this.getSelectedSport();
        const searchResult = {
            pending: this.props.searchResult.pending,
            result: this.groupSearchResult(this.props.searchResult.items)[selectedSport] || {},
        };

        return (
            <SearchView
                config={this.config.searchView}
                menuItems={menuItems}
                selectedSport={selectedSport}
                searchResult={searchResult}
                recentItems={this.props.recentItems}
                onRemoveRecentSearch={this.onRemoveRecentSearch}
                onSportClick={this.onSportClick}
                initiallyActive={this.props.initiallyActive}
                onSearchClose={this.props.onSearchClose}
                searchInputResetState={String(this.props.route)}
            />
        );
    }
}

const mapStateToProps = state => {
    return {
        searchResult: selectResult(state),
        recentItems: selectRecentSearches(state),
        route: selectRoute(state),
        sports: selectSports(state),
    };
};

export default connect(mapStateToProps)(SearchControllerView);
